import { TypedUseSelectorHook, useSelector as useSelectorBase } from 'react-redux';
import type { RootState } from '../store';

const useSelector: TypedUseSelectorHook<RootState> = useSelectorBase;
export default useSelector;
